import { Icons } from './icons';
import { NavLink } from 'react-router-dom';

const items = [
  ['Agents', '/agents', Icons.Bot],
  ['Guardrails', '/guardrails', Icons.Shield],
  ['Knowledge', '/knowledge', Icons.Book],
  ['Business rules', '/business-rules', Icons.Settings],
  ['Conversation flow', '/conversation-flow', Icons.Message],
  ['Intent & wording', '/intent-wording', Icons.Tools],
  ['Analytics', '/analytics', Icons.Analytics],
] as const;

export function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="brand" aria-label="EAirlines">
        <span className="brand-mark">E</span>
      </div>
      <nav aria-label="Primary navigation">
        {items.map(([label, to, Icon]) => (
          <NavLink
            key={label}
            to={to}
            className={({ isActive }) => (isActive ? 'nav-item active' : 'nav-item')}
          >
            <Icon size={19} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <button className="nav-item collapse">
        ← <span>Collapse</span>
      </button>
    </aside>
  );
}
